import auditbmzl from './audit-bmzl'
import marginView from './margin-view'
import bidMethodValidate from './bid-method-validate'
export default {
    path: 'toubiao',
    component: () => import(/*webpackChunkName: 'bidding-toubiao'*/ '@layout/empty'),
    children: [
        auditbmzl,
        marginView,
        bidMethodValidate
    ]
}